// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React from 'react';
import { DndContext, DragOverlay } from '@dnd-kit/core';
import DragPreview from 'Features/folderList/FolderListItem/DragPreview';
import { dashboardCollisionDetection, useDashboardDrag } from '../useDashboardDrag';

// The drag context the dashboard's grid and the map rail share: folder cards reorder among
// themselves and project cards file into folders, with the dragged folder drawn by the overlay
// while its in-flow card stands as the placeholder. The overlay is mounted for folder drags
// only: a mounted overlay, even an empty one, makes dnd-kit treat the drag as overlay-driven
// and stop compensating the in-flow card's translate for the list scrolling under it, and a
// project card follows the pointer in flow.
export const DashboardDragContext = ({ children }: { children: React.ReactNode }) => {
  const { sensors, activeFolder, onDragStart, onDragEnd, onDragCancel } = useDashboardDrag();

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={dashboardCollisionDetection}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onDragCancel={onDragCancel}
    >
      {children}
      {activeFolder && (
        <DragOverlay>
          <DragPreview folder={activeFolder} />
        </DragOverlay>
      )}
    </DndContext>
  );
};

export default DashboardDragContext;
